import { createSignal, SignalOptions } from 'solid-js';

export interface Atom<T> {
    (): T;
    (value: T): T;
}

export function createAtom<T>(value: T, options?: SignalOptions<T>): Atom<T> {
    const [ state, setState] = createSignal(value, options);
    
    return (...args: T[]): T => {
        if (args.length === 1)
            return setState(() => args[0]);

        return state();
    };
}

export default createAtom;